import { useEffect, useState } from 'react';

const DESKTOP_BREAKPOINT = 768;
const MOBILE_PADDING_PX = 12;
const DESKTOP_PADDING_PX = 16;
const DESKTOP_QUERY = `(min-width: ${DESKTOP_BREAKPOINT}px)`;

function getPaddingPx() {
    if (typeof window === 'undefined') {
        return MOBILE_PADDING_PX;
    }

    return window.matchMedia(DESKTOP_QUERY).matches
        ? DESKTOP_PADDING_PX
        : MOBILE_PADDING_PX;
}

/**
 * Returns inline padding styles for ticket/payment modal headers.
 * Mobile (<768px): 12px. Tablet/desktop (≥768px): 16px.
 */
export default function useModalHeaderPadding() {
    const [paddingPx, setPaddingPx] = useState(getPaddingPx);

    useEffect(() => {
        const mq = window.matchMedia(DESKTOP_QUERY);

        const update = () => {
            setPaddingPx(mq.matches ? DESKTOP_PADDING_PX : MOBILE_PADDING_PX);
        };

        update();
        mq.addEventListener('change', update);

        return () => mq.removeEventListener('change', update);
    }, []);

    return {
        paddingStyle: { padding: `${paddingPx}px` },
    };
}
